<!-- right side -->

<img
  class="image fixed right-0 top-0 hidden h-[104px] w-[223px] sm:hidden md:hidden lg:block xl:block"
  src="/assets/images/image-21@2x.png"
  alt="image-"
/>
<div
  class="right__content rounded-lg !bg-white p-[1.5rem] shadow-none sm:max-w-screen-sm sm:bg-[#fcfcfc] sm:p-[1.9rem] xl:p-[2.2rem]"
>
  <h1 class="inline-flex text-2xl font-semibold">
    <a routerLink="/auth/forgot-password">
      <img
        src="assets/images/svgs/chevron-left.svg"
        alt=""
        class="translate-y-[2px]"
      />
    </a>
    <span>{{ isResetPassword() ? 'Reset Password' : 'New Password' }}</span>
  </h1>

  <p class="mb-[20px]">
    Enter and confirm your new password according <br />to the guidelines
  </p>

  <form class="flex flex-col gap-5">
    <div class="gap flex flex-col" style="gap: 0.38rem">
      <label
        for="Password"
        class="block text-sm font-medium leading-6 text-gray-900"
      >
        {{ isResetPassword() ? 'Reset Password' : 'New Password' }}</label
      >
      <div class="">
        <div class="relative mt-0">
          <input
            name="password"
            type="{{ isPasswordVisible ? 'text' : 'password' }}"
            autocomplete="password"
            (input)="checkPasswordStrength($event)"
            [formControl]="newPassword"
            placeholder="******"
            required
            class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-mango sm:text-sm sm:leading-6"
          />
          <span
            (mousedown)="togglePasswordVisibility()"
            class="absolute inset-y-0 end-0 grid place-content-center px-4"
          >
            <svg
              *ngIf="!isPasswordVisible"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2.35537 5.53854C2.19221 5.15782 1.7513 4.98146 1.37058 5.14463C0.989854 5.30779 0.81349 5.7487 0.976657 6.12942L2.35537 5.53854ZM12.9887 11.1079L12.714 10.41L12.9887 11.1079ZM7.63866 11.5169C7.86457 11.1698 7.76625 10.7052 7.41906 10.4793C7.07188 10.2534 6.60729 10.3517 6.38139 10.6989L7.63866 11.5169ZM5.20404 12.5083C4.97814 12.8555 5.07646 13.3201 5.42364 13.546C5.77083 13.7719 6.23541 13.6735 6.46132 13.3264L5.20404 12.5083ZM19.022 6.12942C19.1852 5.7487 19.0088 5.30779 18.6281 5.14463C18.2474 4.98146 17.8065 5.15782 17.6433 5.53855L19.022 6.12942ZM15.8327 9.27468L15.3194 8.72783V8.72783L15.8327 9.27468ZM16.5524 11.055C16.8452 11.3479 17.3201 11.3479 17.613 11.055C17.9059 10.7621 17.9059 10.2872 17.613 9.99435L16.5524 11.055ZM9.24935 13.7507C9.24935 14.1649 9.58514 14.5007 9.99935 14.5007C10.4136 14.5007 10.7493 14.1649 10.7493 13.7507H9.24935ZM13.5374 13.3264C13.7633 13.6735 14.2279 13.7719 14.5751 13.546C14.9222 13.32 15.0206 12.8555 14.7947 12.5083L13.5374 13.3264ZM4.69635 9.80501C4.98924 9.51212 4.98924 9.03725 4.69635 8.74435C4.40345 8.45146 3.92858 8.45146 3.63569 8.74435L4.69635 9.80501ZM2.38569 9.99435C2.09279 10.2872 2.09279 10.7621 2.38569 11.055C2.67858 11.3479 3.15345 11.3479 3.44635 11.055L2.38569 9.99435ZM9.99935 10.9173C7.35879 10.9173 5.46068 9.60359 4.19478 8.24031C3.56205 7.55891 3.09781 6.87515 2.79226 6.36183C2.6399 6.10588 2.52817 5.89427 2.45565 5.74923C2.41942 5.67676 2.39306 5.62108 2.37639 5.585C2.36806 5.56696 2.36216 5.55383 2.35866 5.54597C2.35691 5.54204 2.35576 5.53942 2.35522 5.53817C2.35494 5.53754 2.35482 5.53726 2.35485 5.53732C2.35486 5.53735 2.35491 5.53747 2.355 5.53767C2.35504 5.53777 2.35514 5.53799 2.35516 5.53804C2.35526 5.53828 2.35537 5.53854 1.66602 5.83398C0.976657 6.12942 0.976789 6.12973 0.97693 6.13006C0.97699 6.1302 0.977141 6.13055 0.977261 6.13083C0.977502 6.13139 0.977781 6.13204 0.9781 6.13277C0.978737 6.13425 0.979531 6.13608 0.980482 6.13825C0.982383 6.14261 0.984912 6.14836 0.988072 6.15547C0.994391 6.16968 1.00324 6.18931 1.01464 6.21399C1.03744 6.26336 1.07049 6.33301 1.11401 6.42005C1.20099 6.59401 1.33015 6.83813 1.50332 7.12906C1.84881 7.70948 2.37415 8.48405 3.09559 9.26099C4.53802 10.8144 6.80657 12.4173 9.99935 12.4173V10.9173ZM12.714 10.41C11.9192 10.7228 11.0177 10.9173 9.99935 10.9173V12.4173C11.2142 12.4173 12.3017 12.1843 13.2634 11.8058L12.714 10.41ZM6.38139 10.6989L5.20404 12.5083L6.46132 13.3264L7.63866 11.5169L6.38139 10.6989ZM18.3327 5.83398C17.6433 5.53855 17.6434 5.53839 17.6435 5.53825C17.6435 5.53821 17.6435 5.53807 17.6436 5.53799C17.6436 5.53783 17.6437 5.5377 17.6437 5.5376C17.6438 5.5374 17.6439 5.5373 17.6439 5.53731C17.6438 5.53734 17.6436 5.5378 17.6433 5.53868C17.6425 5.54045 17.641 5.54392 17.6387 5.54904C17.6341 5.55926 17.6265 5.57604 17.6159 5.59887C17.5946 5.64455 17.5611 5.71438 17.5152 5.80442C17.4232 5.98466 17.282 6.24488 17.0895 6.55388C16.703 7.17406 16.1174 7.97883 15.3194 8.72783L16.346 9.82153C17.2635 8.96035 17.9278 8.04477 18.3625 7.34714C18.5806 6.99725 18.7426 6.6992 18.8514 6.4859C18.9059 6.37917 18.9471 6.29341 18.9754 6.2327C18.9895 6.20233 19.0005 6.17821 19.0082 6.16083C19.0121 6.15215 19.0152 6.14514 19.0175 6.13989C19.0187 6.13726 19.0196 6.13507 19.0204 6.13332C19.0207 6.13245 19.0211 6.13169 19.0213 6.13104C19.0215 6.13071 19.0216 6.13041 19.0217 6.13015C19.0218 6.13001 19.0219 6.12983 19.0219 6.12976C19.022 6.12959 19.022 6.12942 18.3327 5.83398ZM15.3194 8.72783C14.6126 9.39129 13.7474 10.0032 12.714 10.41L13.2634 11.8058C14.5091 11.3155 15.5314 10.5861 16.346 9.82153L15.3194 8.72783ZM15.3024 9.80501L16.5524 11.055L17.613 9.99435L16.363 8.74435L15.3024 9.80501ZM9.24935 11.6673V13.7507H10.7493V11.6673H9.24935ZM12.36 11.5169L13.5374 13.3264L14.7947 12.5083L13.6173 10.6989L12.36 11.5169ZM3.63569 8.74435L2.38569 9.99435L3.44635 11.055L4.69635 9.80501L3.63569 8.74435Z"
                fill="#D0D5DD"
              />
            </svg>
            <svg
              *ngIf="isPasswordVisible"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              version="1.1"
              width="20"
              height="20"
              viewBox="0 0 256 256"
              xml:space="preserve"
            >
              <defs></defs>
              <g
                style="
                  stroke: none;
                  stroke-width: 0;
                  stroke-dasharray: none;
                  stroke-linecap: butt;
                  stroke-linejoin: miter;
                  stroke-miterlimit: 10;
                  fill: none;
                  fill-rule: nonzero;
                  opacity: 1;
                "
                transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
              >
                <path
                  d="M 45 72.864 C 44.999 72.864 45 72.864 45 72.864 c -14.889 0 -29.874 -8.944 -44.538 -26.586 c -0.616 -0.741 -0.616 -1.816 0 -2.557 C 15.126 26.08 30.111 17.135 45 17.135 c 14.889 0 29.874 8.945 44.539 26.586 c 0.616 0.741 0.616 1.816 0 2.557 C 74.874 63.919 59.888 72.864 45 72.864 z M 4.615 45 C 18.128 60.837 31.709 68.864 45 68.864 S 71.872 60.837 85.386 45 C 71.872 29.163 58.29 21.135 45 21.135 S 18.128 29.163 4.615 45 z"
                  style="
                    stroke: none;
                    stroke-width: 1;
                    stroke-dasharray: none;
                    stroke-linecap: butt;
                    stroke-linejoin: miter;
                    stroke-miterlimit: 10;
                    fill: rgb(0, 0, 0);
                    fill-rule: nonzero;
                    opacity: 1;
                  "
                  transform=" matrix(1 0 0 1 0 0) "
                  stroke-linecap="round"
                />
                <path
                  d="M 45 64.103 c -10.533 0 -19.102 -8.569 -19.102 -19.103 c 0 -10.533 8.569 -19.102 19.102 -19.102 c 10.533 0 19.103 8.569 19.103 19.102 C 64.103 55.533 55.533 64.103 45 64.103 z M 45 29.898 c -8.327 0 -15.102 6.775 -15.102 15.102 S 36.673 60.103 45 60.103 S 60.103 53.327 60.103 45 S 53.327 29.898 45 29.898 z"
                  style="
                    stroke: none;
                    stroke-width: 1;
                    stroke-dasharray: none;
                    stroke-linecap: butt;
                    stroke-linejoin: miter;
                    stroke-miterlimit: 10;
                    fill: rgb(0, 0, 0);
                    fill-rule: nonzero;
                    opacity: 1;
                  "
                  transform=" matrix(1 0 0 1 0 0) "
                  stroke-linecap="round"
                />
              </g>
            </svg>
          </span>
        </div>
      </div>
    </div>
    <div>
      <div class="mb-2 flex items-center gap-1">
        <app-password-validity
          [valid]="isAtLeastEightChars"
        ></app-password-validity>
        <p class="text-wrapper-2 whitespace-nowrap text-[15px]">
          Password must be at least 8 characters long.
        </p>
      </div>

      <div class="flex items-center gap-1">
        <app-password-validity
          [valid]="ruleListComplete"
        ></app-password-validity>

        <p class="text-wrapper-2 whitespace-nowrap text-[15px]">
          Password must include the following:
        </p>
      </div>
      <div
        class="one-uppercase-letter mt-n1 font-Avenir-Book text-14 leading-20 relative ml-3 w-[200px] font-normal text-mango-grey"
      >
        <div class="flex items-center gap-1">
          <app-password-validity
            [valid]="hasOneUppercaseChar"
          ></app-password-validity>
          One uppercase letter
        </div>
        <div class="flex items-center gap-1">
          <app-password-validity
            [valid]="hasOneLowercaseChar"
          ></app-password-validity>
          One lowercase letter
        </div>
        <div class="flex items-center gap-1">
          <app-password-validity [valid]="hasOneNumber"></app-password-validity>
          One is number
        </div>
        <div class="flex items-center gap-1">
          <app-password-validity
            [valid]="hasOneSpecialChar"
          ></app-password-validity>
          One special character
        </div>
      </div>
    </div>

    <div class="gap flex flex-col" style="gap: 0.38rem">
      <label
        for="Password"
        class="block text-sm font-medium leading-6 text-gray-900"
        >Confirm New Password</label
      >
      <div>
        <div class="">
          <div class="relative mt-0">
            <input
              name="password"
              type="{{ PasswordVisible ? 'text' : 'password' }}"
              autocomplete="password"
              [formControl]="confirmPassord"
              placeholder="******"
              (input)="matchPassword()"
              class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset {{
                matchPassword()
                  ? 'focus:ring-green-700'
                  : 'ring-red-700 focus:ring-red-700'
              }} sm:text-sm sm:leading-6"
            />
            <span
              (mousedown)="togglePasswordVisible()"
              class="absolute inset-y-0 end-0 grid place-content-center px-4"
            >
              <svg
                *ngIf="!PasswordVisible"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2.35537 5.53854C2.19221 5.15782 1.7513 4.98146 1.37058 5.14463C0.989854 5.30779 0.81349 5.7487 0.976657 6.12942L2.35537 5.53854ZM12.9887 11.1079L12.714 10.41L12.9887 11.1079ZM7.63866 11.5169C7.86457 11.1698 7.76625 10.7052 7.41906 10.4793C7.07188 10.2534 6.60729 10.3517 6.38139 10.6989L7.63866 11.5169ZM5.20404 12.5083C4.97814 12.8555 5.07646 13.3201 5.42364 13.546C5.77083 13.7719 6.23541 13.6735 6.46132 13.3264L5.20404 12.5083ZM19.022 6.12942C19.1852 5.7487 19.0088 5.30779 18.6281 5.14463C18.2474 4.98146 17.8065 5.15782 17.6433 5.53855L19.022 6.12942ZM15.8327 9.27468L15.3194 8.72783V8.72783L15.8327 9.27468ZM16.5524 11.055C16.8452 11.3479 17.3201 11.3479 17.613 11.055C17.9059 10.7621 17.9059 10.2872 17.613 9.99435L16.5524 11.055ZM9.24935 13.7507C9.24935 14.1649 9.58514 14.5007 9.99935 14.5007C10.4136 14.5007 10.7493 14.1649 10.7493 13.7507H9.24935ZM13.5374 13.3264C13.7633 13.6735 14.2279 13.7719 14.5751 13.546C14.9222 13.32 15.0206 12.8555 14.7947 12.5083L13.5374 13.3264ZM4.69635 9.80501C4.98924 9.51212 4.98924 9.03725 4.69635 8.74435C4.40345 8.45146 3.92858 8.45146 3.63569 8.74435L4.69635 9.80501ZM2.38569 9.99435C2.09279 10.2872 2.09279 10.7621 2.38569 11.055C2.67858 11.3479 3.15345 11.3479 3.44635 11.055L2.38569 9.99435ZM9.99935 10.9173C7.35879 10.9173 5.46068 9.60359 4.19478 8.24031C3.56205 7.55891 3.09781 6.87515 2.79226 6.36183C2.6399 6.10588 2.52817 5.89427 2.45565 5.74923C2.41942 5.67676 2.39306 5.62108 2.37639 5.585C2.36806 5.56696 2.36216 5.55383 2.35866 5.54597C2.35691 5.54204 2.35576 5.53942 2.35522 5.53817C2.35494 5.53754 2.35482 5.53726 2.35485 5.53732C2.35486 5.53735 2.35491 5.53747 2.355 5.53767C2.35504 5.53777 2.35514 5.53799 2.35516 5.53804C2.35526 5.53828 2.35537 5.53854 1.66602 5.83398C0.976657 6.12942 0.976789 6.12973 0.97693 6.13006C0.97699 6.1302 0.977141 6.13055 0.977261 6.13083C0.977502 6.13139 0.977781 6.13204 0.9781 6.13277C0.978737 6.13425 0.979531 6.13608 0.980482 6.13825C0.982383 6.14261 0.984912 6.14836 0.988072 6.15547C0.994391 6.16968 1.00324 6.18931 1.01464 6.21399C1.03744 6.26336 1.07049 6.33301 1.11401 6.42005C1.20099 6.59401 1.33015 6.83813 1.50332 7.12906C1.84881 7.70948 2.37415 8.48405 3.09559 9.26099C4.53802 10.8144 6.80657 12.4173 9.99935 12.4173V10.9173ZM12.714 10.41C11.9192 10.7228 11.0177 10.9173 9.99935 10.9173V12.4173C11.2142 12.4173 12.3017 12.1843 13.2634 11.8058L12.714 10.41ZM6.38139 10.6989L5.20404 12.5083L6.46132 13.3264L7.63866 11.5169L6.38139 10.6989ZM18.3327 5.83398C17.6433 5.53855 17.6434 5.53839 17.6435 5.53825C17.6435 5.53821 17.6435 5.53807 17.6436 5.53799C17.6436 5.53783 17.6437 5.5377 17.6437 5.5376C17.6438 5.5374 17.6439 5.5373 17.6439 5.53731C17.6438 5.53734 17.6436 5.5378 17.6433 5.53868C17.6425 5.54045 17.641 5.54392 17.6387 5.54904C17.6341 5.55926 17.6265 5.57604 17.6159 5.59887C17.5946 5.64455 17.5611 5.71438 17.5152 5.80442C17.4232 5.98466 17.282 6.24488 17.0895 6.55388C16.703 7.17406 16.1174 7.97883 15.3194 8.72783L16.346 9.82153C17.2635 8.96035 17.9278 8.04477 18.3625 7.34714C18.5806 6.99725 18.7426 6.6992 18.8514 6.4859C18.9059 6.37917 18.9471 6.29341 18.9754 6.2327C18.9895 6.20233 19.0005 6.17821 19.0082 6.16083C19.0121 6.15215 19.0152 6.14514 19.0175 6.13989C19.0187 6.13726 19.0196 6.13507 19.0204 6.13332C19.0207 6.13245 19.0211 6.13169 19.0213 6.13104C19.0215 6.13071 19.0216 6.13041 19.0217 6.13015C19.0218 6.13001 19.0219 6.12983 19.0219 6.12976C19.022 6.12959 19.022 6.12942 18.3327 5.83398ZM15.3194 8.72783C14.6126 9.39129 13.7474 10.0032 12.714 10.41L13.2634 11.8058C14.5091 11.3155 15.5314 10.5861 16.346 9.82153L15.3194 8.72783ZM15.3024 9.80501L16.5524 11.055L17.613 9.99435L16.363 8.74435L15.3024 9.80501ZM9.24935 11.6673V13.7507H10.7493V11.6673H9.24935ZM12.36 11.5169L13.5374 13.3264L14.7947 12.5083L13.6173 10.6989L12.36 11.5169ZM3.63569 8.74435L2.38569 9.99435L3.44635 11.055L4.69635 9.80501L3.63569 8.74435Z"
                  fill="#D0D5DD"
                />
              </svg>
              <svg
                *ngIf="PasswordVisible"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                version="1.1"
                width="20"
                height="20"
                viewBox="0 0 256 256"
                xml:space="preserve"
              >
                <defs></defs>
                <g
                  style="
                    stroke: none;
                    stroke-width: 0;
                    stroke-dasharray: none;
                    stroke-linecap: butt;
                    stroke-linejoin: miter;
                    stroke-miterlimit: 10;
                    fill: none;
                    fill-rule: nonzero;
                    opacity: 1;
                  "
                  transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
                >
                  <path
                    d="M 45 72.864 C 44.999 72.864 45 72.864 45 72.864 c -14.889 0 -29.874 -8.944 -44.538 -26.586 c -0.616 -0.741 -0.616 -1.816 0 -2.557 C 15.126 26.08 30.111 17.135 45 17.135 c 14.889 0 29.874 8.945 44.539 26.586 c 0.616 0.741 0.616 1.816 0 2.557 C 74.874 63.919 59.888 72.864 45 72.864 z M 4.615 45 C 18.128 60.837 31.709 68.864 45 68.864 S 71.872 60.837 85.386 45 C 71.872 29.163 58.29 21.135 45 21.135 S 18.128 29.163 4.615 45 z"
                    style="
                      stroke: none;
                      stroke-width: 1;
                      stroke-dasharray: none;
                      stroke-linecap: butt;
                      stroke-linejoin: miter;
                      stroke-miterlimit: 10;
                      fill: rgb(0, 0, 0);
                      fill-rule: nonzero;
                      opacity: 1;
                    "
                    transform=" matrix(1 0 0 1 0 0) "
                    stroke-linecap="round"
                  />
                  <path
                    d="M 45 64.103 c -10.533 0 -19.102 -8.569 -19.102 -19.103 c 0 -10.533 8.569 -19.102 19.102 -19.102 c 10.533 0 19.103 8.569 19.103 19.102 C 64.103 55.533 55.533 64.103 45 64.103 z M 45 29.898 c -8.327 0 -15.102 6.775 -15.102 15.102 S 36.673 60.103 45 60.103 S 60.103 53.327 60.103 45 S 53.327 29.898 45 29.898 z"
                    style="
                      stroke: none;
                      stroke-width: 1;
                      stroke-dasharray: none;
                      stroke-linecap: butt;
                      stroke-linejoin: miter;
                      stroke-miterlimit: 10;
                      fill: rgb(0, 0, 0);
                      fill-rule: nonzero;
                      opacity: 1;
                    "
                    transform=" matrix(1 0 0 1 0 0) "
                    stroke-linecap="round"
                  />
                </g>
              </svg>
            </span>
          </div>
        </div>
      </div>
    </div>

    <div
      [ngClass]="{
        'cursor-not-allowed':
          isLoading ||
          !matchPassword() ||
          newPassword.invalid ||
          confirmPassord.invalid
      }"
    >
      <button
        type="button"
        mango-button
        (click)="submitPassword()"
        [loading]="isLoading"
        [disabled]="
          isLoading ||
          !matchPassword() ||
          newPassword.invalid ||
          confirmPassord.invalid
        "
        class="!mt-0 w-full justify-center"
      >
        <span *ngIf="isLoading" spin></span>
        @if (!isLoading) {
          Confirm
        }
      </button>
    </div>

    <a routerLink="/auth/login" class="text-center text-mango">
      Back to Login
    </a>
  </form>
</div>
